<template>
  <div class="discussion_mgr">
    <PageHeader
    :hero="require('../assets/discussion_mgr/hero.jpg')" 
    title="エンタープライズ、組込み領域 × マネージャー" 
    :image="require('../assets/discussion_mgr/title.svg')" 
    :imageSp="require('../assets/discussion_mgr/title_sp.svg')" 
    alt="Cross talk 2" 
    intro="入社14年〜20年目のマネージャークラス4名によるクロストーク。<br>
          担当領域はエンタープライズと組込みです。<br>
          彼らは長い豆蔵のキャリアの中で、どのような修羅場を突破してきたのか。<br>
          そして、豆蔵の変わらない良さは何なのか。<br>
          一人ひとりの本音を語ってくれました。" 
    >
      <div class="people-wrap">

        <PeopleProfile
        color="yellow" 
        :image="require('../assets/discussion_mgr/masahiro.jpg')" 
        alt="Masahiro" 
        background="Masahiro<br>
            技術コンサルティング事業部<br>
            第二コンサルティング部<br>
            主幹コンサルタント<br>
            50歳 入社17年目" 
        profile="豆蔵がスタートアップ企業だった当時、その雰囲気と技術力の高さに惹かれて中途入社。現在は、エンタープライズ領域に於ける大規模案件のプロジェクトマネージャーや自社内の技術支援を務める。" 
        />
        <PeopleProfile
        color="red" 
        :image="require('../assets/discussion_mgr/shinji.jpg')" 
        alt="Shinji" 
        background="
            Shinji<br>
            技術コンサルティング事業部<br>
            第二コンサルティング部<br>
            シニアコンサルタント<br>
            39歳 入社15年目" 
        profile="豆蔵のオブジェクト指向に関する高い技術力と、開発思想に共感して中途入社。現在は、エンタープライズ領域に於けるプロジェクトリーダーや自社組織のグループリーダーを務める。" 
        />
        <PeopleProfile
        color="green" 
        :image="require('../assets/discussion_mgr/tatsuki.jpg')" 
        alt="Tatsuki" 
        background="Tatsuki<br>
            技術コンサルティング事業部<br>
            第一コンサルティング部<br>
            主幹コンサルタント<br>
            47歳 入社20年目" 
        profile="オブジェクト指向に関して、高い技術力を持つエンジニアが立ち上げる会社があると聞き、豆蔵に参画。現在は、組込み領域に於ける上流コンサルや講師、自社組織のグループリーダーを務める。" 
        />
        <PeopleProfile
        color="navy" 
        :image="require('../assets/discussion_mgr/yasumasa.jpg')" 
        alt="Yasumasa" 
        background="Yasumasa<br>
            技術コンサルティング事業部<br>
            第一コンサルティング部<br>
            コンサルタント<br>
            46歳 入社14年目
          </p>" 
        profile="AV機器メーカーでの制御システム開発エンジニアを経て、「多くの会社の問題を解決したい」と豆蔵に中途入社。現在は、組込み領域に於ける各プロジェクトのコンサルタントを務める。" 
        />
      </div>
    </PageHeader>
    <DiscussionArticle
    :image="require('../assets/discussion_mgr/back01.jpg')" 
    :imageSp="require('../assets/discussion_mgr/back01_sp.jpg')" 
    title="豆蔵のコンサルティングの特長" 
    name="Shinji" 
    comment="「プロジェクト自体がそもそも必要なのか、<br>
              から考えることができる」" 
    >
      <div class="article-body">
        <div class="text">
          <p>
            <span class="name name-yellow">
              Masahiro
            </span>
            <i>豆蔵のコンサルティングの特長は、最も根っ子の部分から携われることですね。</i>大小様々なプロジェクトがありますが、「そもそも何をつくるのか」「どのように人を集めて、何をやってもらうのか」ということから、考え尽くして実行していく。豆蔵は、アーキテクチャを設計するだけでなく、実際にコードを書いてシステムを構築します。ただし、大規模プロジェクトでは自社メンバーだけでは全開発領域を賄えないため、マルチベンターで他社のSIerと協業するケースも多くあります。その場合は、大規模なシステムを効率よく開発し、性能・保守性などの非機能要件を達成するために、私たちは正しい構造設計を行うことに気をつけています。<i>構造設計の精度によって、プロジェクト全体の工数も大きく変わってきますから。</i>また、技術選定においては、案件との相性を考慮するのはもちろんですが、その技術が生まれてきた背景までを綿密にリサーチします。メリットを正確に把握することができますし、中長期的に活用できるかどうか判断もつきますので。Shinjiさんは、どう思いますか？
 
          </p>
          <p>
            <span class="name name-red">   
              Shinji
            </span>
            いま、Masahiroさんが言ってくれたように、プロジェクトを受託した際に、その根源から考えることが1つの特長だと思います。<i>仮に、クライアントの目指す目標・ビジョン等にそぐわない要求の場合は、「必要ありません」と伝えることもあります。</i>「何を改善するのか：what」に加えて、「そもそもなぜ改善が必要なのか：why」にまでさかのぼって、クライアントに貢献したい人には向いている仕事だと思いますね。もう1つの特長を挙げるとすれば、クライアントの業種・課題がともに幅広いこと。私自身、入社して15年が経つのですが、振り返れば、様々なクライアントの事業課題に向き合ってきました。我々はクライアントの事業に関しては、その領域のプロではありませんし、その領域で主導権を得ようとはしません。<br>
            ですが、<i>事業や業務への理解を深め、クライアントと議論が交わせるくらいまで踏み込みます。</i><br>
            反対に、システムでの解決策となると、今度はIT専門知識や技術を利用しますので、クライアント側がその良し悪しを判別できるよう、難しい技術をわかりやすく噛み砕いて伝えて、理解を得ることを大切にしています。自分の中での引き出しを常に増やすことで、提案の幅も拡がり、技術者としての成長も実感することができました。
          </p>
          <p>
            <span class="name name-green">
              Tatsuki
            </span>
            私とYasumasaさんは、組込みの領域を担当しているのですが、根っ子の部分はエンタープライズ領域とあまり変わらないと思います。たとえば、私が携わった複写機メーカーのプロジェクトでは、<i>「そもそも複写機は何をしなければならない機械なのか？」を徹底的に考え尽くしました。</i>複写機は、最初の製品を起点に、多くの派生機種を作っていくタイプの製品ですので、土台となる普遍的な部分をきちんと作ることが重要でした。要求分析を行い、仕様を決めて、アーキテクチャを設計して、最初の適用機種のコードに落としていく。その過程を丁寧に進めていくことができたのが成功要因だったと思います。コンサルタントとして、プロセスの定義はもとより、仕様書の書き方やオブジェクト指向の指導、コードレビュー等、様々な形でご支援しました。掛かった期間は約4年。<i>2000年代中頃にそのプラットフォームを適用した最初の製品が出たのですが、そこから10年以上経った今でも、その上で製品がつくられています。</i>Yasumasaさんも、入社してから長く経ちましたが、豆蔵の特長はどんなところにありますかね？
          </p>
          <p>
            <span class="name name-navy">
               Yasumasa
            </span>
            私は2006年に入社したのですが、「SysML（システムをモデリングするための記述言語）」に出会ったことが個人的な転機になりました。その時点で、主にソフトウェア設計のためにUMLを活用したことはあったのですが、SysMLというモデリング言語が登場して、これが自分の肌に合いました。<i>豆蔵が培ってきた「技術志向」のカルチャーがベースにあったからこそ、未だ世間に知られていない段階で、この新しいモデリング言語を習得することができましたし、</i>クライアントに大きな価値をもたらせました。課題の根っ子を重視するのと同時に、「どうやって解決するのか：How」の部分にも、私たちはこだわりを持っています。当時は、UMLがあれば、システムズエンジニアリングのための言語はいらないというような風潮もありました。しかし、豆蔵ではこの技術を広めていくことを奨励してくれました。
          </p>
        </div>
        <div class="image">
          <img src="../assets/discussion_mgr/image01.jpg" alt="" class="over_display">
          <img src="../assets/discussion_mgr/image01_sp.jpg" alt="" class="under_display">
          <img src="../assets/discussion_mgr/image02.jpg" alt="" class="over_display">
          <img src="../assets/discussion_mgr/image02_sp.jpg" alt="" class="under_display">
        </div>
      </div>
    </DiscussionArticle>
    <DiscussionArticle
    :image="require('../assets/discussion_mgr/back02.jpg')" 
    :imageSp="require('../assets/discussion_mgr/back02_sp.jpg')" 
    title="印象に残っているプロジェクトの事例" 
    name="Tatsuki" 
    comment="「複写機に搭載したプラットフォームは、
              15年経っても現役です」" 
    >
      <div class="article-body">
        <div class="text">
          <p>
            <span class="name name-yellow">
              Masahiro
            </span>
            ある大手金融機関の基幹システム刷新が、思い出深いですね。そのクライアントは、日本を代表する大手SIer数社に依頼したのですが、どの会社も満足な設計・実装ができるスキルのメンバーをアサインすることができずプロジェクトが空中分解するところでした。そこで豆蔵に話が回ってきて、要件定義の支援を実施するとともに実際の設計・実装も担ったのです。業務の共通部分を担うプラットフォームから開発して、アプリケーションもつくりました。<i>基幹システム刷新は、クライアントにとって20年に1度の大手術。</i>私は立ち上げの4年くらいでプロジェクトを離れましたが、豆蔵はその後も継続的にプロジェクトに参画し、クライアントと良好な信頼関係を構築しながら基幹システムの機能追加・改善に貢献し続けています。この息の長いシステム構築に携わることで、多くの学びを得られました。関与した技術者全員が、大きく成長したプロジェクトだったように思います。
          </p>
          <p>
            <span class="name name-red">
              Shinji
            </span>
            私は、Masahiroさんと同じエンタープライズ領域を担当しているのですが、印象的な事例を1つ挙げるとすれば、あるメーカーのプロジェクトですね。その会社の技術者が使用する、設計支援システムを豆蔵が開発しました。私たちは、ただシステムを納品するだけでなく、<i>「それを活用することによって本当に業務が効率化されるのか」、「実際に使う人に喜んでいただけるか」</i>といったことまで考え尽くして構築します。このクライアントの責任者とは頻繁に意見をぶつけ合いました。単に技術論を振りかざすだけでは、話が前に進まない。その方に「いかに仲間になっていただくか」を考えて行動しました。朝早く出社される方でしたので、重要なことを伝える時は早朝に待ち伏せして「いま、お時間いただけますか」とその場で捕まえていましたね（笑）。私の熱意がその方の想いに火をつけることができ、プロジェクトは一気に進みました。新技術を用いて開発されたその設計支援システムは、クライアントの開発環境を一新し、それは今でも同社の競争力の源泉になっていると聞いています。組込み領域だといかがですか？
          </p>
          <p>
            <span class="name name-green">
              Tatsuki
            </span>
            現在もクライアントに活用いただいているシステムを構築したという観点では、先ほども少しお話ししましたが、複写機メーカーのプロジェクトで開発したプラットフォームは、10年以上経った今でもそのまま使われていますね。「そもそも複写機は何をするための機械なのか？」を考え尽くすことによって、各ドメインの機能を明確化することができました。<i>実は、この初期フェーズにびっくりするくらいの時間を掛けています。</i>クライアントの責任者が理解のある方でしたので、<i>このタイミングでユースケースやモデルを一通りつくることができました。</i>じっくりと進めることができるプロジェクトでしたので、私たちは開発フェーズに入っても急ぎませんでした。明確化したドメインをもとに、まずは全体のアーキテクチャを設計し、メカニズムをつくって、さらに各サブシステムの設計をきちんと行って、ようやくコーディングに入りました。このプロセスをかなり丁寧に踏むことによって、後から何が出てきても問題の無い、耐用性の長いシステムがつくれたと思っています。
          </p>
          <p>
            <span class="name name-navy">
              Yasumasa
            </span>
            確かに、組込領域では、ソフトウェアとハードウェアの双方を意識する必要があります。私は、あるメーカーの短焦点プロジェクタの組込みシステムを開発しました。壁のすぐ前に置いても、映写が可能なプロジェクタなのですが、SysMLを活用することによって、ソフトウェア以外の部分も考慮して設計を進めることができました。当時はまだ珍しい技術でしたので、導入には課題がありましたが、試行錯誤を重ねることで、乗り越えることができました。その他でのプロジェクトでも、SysMLを試験的に導入することによって、ノウハウが蓄積されたので、日本経済新聞社からお声掛けいただき連載記事を書くことにもつながりました。こういった活動を通じて<i>豆蔵の存在やノウハウを世の中に公開していくことの重要性に気づくことができた</i>のは、自分にとっては大きかったですね。私は、「技術者の使命は、世の中の悩みを解決すること」だと思っています。目の前のクライアントに対して、コンサルティングやシステムの実装という形で貢献するだけではなく、発信した情報を通じて、悩みが解決するクライアントもいるかもしれない。私たちが蓄積してきたノウハウは、できるだけ公開していきたいですね。
          </p>
        </div>
        <div class="image">
          <img src="../assets/discussion_mgr/image03.jpg" alt="" class="over_display">
          <img src="../assets/discussion_mgr/image03_sp.jpg" alt="" class="under_display">
          <img src="../assets/discussion_mgr/image04.jpg" alt="" class="over_display">
          <img src="../assets/discussion_mgr/image04_sp.jpg" alt="" class="under_display">
        </div>
      </div>
    </DiscussionArticle>
    <DiscussionArticle
    :image="require('../assets/discussion_mgr/back03.jpg')" 
    :imageSp="require('../assets/discussion_mgr/back03_sp.jpg')" 
    title="長く豆蔵にいる理由" 
    name="Yasumasa" 
    comment="「会社として、常にリスクよりも<br>
              チャレンジを優先してくれるから」" 
    >
      <div class="article-body">
        <div class="text">
          <p>
            <span class="name name-yello">
              Masahiro
            </span>
            豆蔵には、テクノロジーの適正な利用やアーキテクチャを重視するカルチャーがあります。システムを開発するときに、方式設計や検証は必ず行いますし、いきなりコードを書いているように見える人も、ちゃんと考えて書いている。「そもそも」の根っ子の部分から考えて、構築するシステムのモジュール分割とその依存関係についても重要視します。<i>機能要件を満たしつつ、機能追加や仕様変更のために手に入れやすい設計を実現することが、会社として徹底されているのです。</i>このような設計思想のもとで、メンバーとはプロジェクトを組めるので、コミュニケーションをスムーズに行えます。「とにかくコードを書く！」ではなく、「そのコードは何のため？」という会話を行いながら仕事ができる。仮にコードを10万行書いたとしても、すごく整理されたものもあれば、カオスなものもあります。豆蔵では、前者が当たり前というカルチャーができているので、入社して17年目になりますが、ずっと気持ち良く働けているのだと思いますね。Sinjiさんは15年目でしたよね？
          </p>
          <p>
            <span class="name name-red">
              Shinji
            </span>
            そうです。もう15年になりますね。Masahiroさんが言ったことと近いのですが、オブジェクト指向が染み付いた社員同士で、本質的なディスカッションができるから、この環境が好きなのだと思います。その上で、一人ひとりの技術者が特筆的な何かを持っているのも、魅力に感じています。高い品質のコードを書ける人がいれば、オブジェクト指向に関する詳しいノウハウを持っている人もいる。<i>得意分野が異なる技術者同士で、有益な議論ができるのです。</i>また、技術に対するカルチャーがしっかりしているので、<i>抽象度が異なる話題を行き来しながら、自由にディスカッションをしています。</i>顧客の要求レベルの話と、実装レベルの話がごっちゃにならない。私は、コンサルタントとして、他の会社の技術者と話をすることも多いですが、同じように会話ができる人は希少かもしれません。
          </p>
          <p>
            <span class="name name-green">
              Tatsuki
            </span>
            今、Shinjiさんが少し触れてくれましたが、豆蔵の中には、それぞれの専門領域のエキスパートが数多く在籍しています。何か困ったことがあれば、社内に相談できる人がいますし、<i>日本国内で十本の指に入るくらいのレベルの方も多いです。</i>社内の相談で得られるものがここまで大きい環境は、他には無いと思います。もう1つ、私は20年目になるのですが、長く在籍している理由として、「豆蔵の次の転職先として、イメージできる会社が無い」ということも挙げられます。色々な会社を見てきましたが、同じようなタイプの会社と出会ったことがありません。ですから、退職する人は起業する人が多いですね。またそうした、元豆蔵の人達に協力していただくことも多くて、<i>退職された人もエンジニアとして信頼しているというのも豆蔵の特長</i>かなと思います。
          </p>
          <p>
            <span class="name name-navy">
              Yasumasa
            </span>
            Tatsukiさんが言ったように、<i>レベルの高いエンジニアが活躍している理由には、自由にやらせてくれる社風があると思います。</i>プロジェクトの進め方や課題解決のための技術など、現場にいるコンサルタントの裁量が大きい。豆蔵に転職してきた理由の1つに、「多くの会社の問題を解決したい」という思いがありましたが、その思いが多少なりとも実現できているので、13年にわたって続けてこられたのだと思います。もう1つ、技術的なチャレンジを奨励してくれるのもありがたいですね。先ほどのSysMLの話でもそうですが、当時は導入のプロセスも確立していなければ、教育手法も皆無でした。「どこから着手すればいいの？」という状態でしたが、<i>会社としてはリスクよりもチャレンジを優先してくれました。</i>
          </p>
        </div>
        <div class="image">
          <img src="../assets/discussion_mgr/image05.jpg" alt="" class="over_display">
          <img src="../assets/discussion_mgr/image05_sp.jpg" alt="" class="under_display">
          <img src="../assets/discussion_mgr/image06.jpg" alt="" class="over_display">
          <img src="../assets/discussion_mgr/image06_sp.jpg" alt="" class="under_display">
        </div>
      </div>
    </DiscussionArticle>
    <DiscussionArticle
    :image="require('../assets/discussion_mgr/back04.jpg')" 
    :imageSp="require('../assets/discussion_mgr/back04_sp.jpg')" 
    title="求める人物像" 
    name="Masahiro" 
    comment="「目的ありきで<br>  
              技術を扱える方と、働きたい」" 
    >
      <div class="article-body">
        <div class="text">
          <p>
            <span class="name name-yellow">
              Masahiro
            </span>
            私が入社した2000年代初頭くらいのオブジェクト指向が実システムに適用され始めた頃と比べると、ソフトウェアの開発技術はすごく進化していると思います。アーキテクチャもプログラミング言語も、当時とは比べものにならない。そのキャッチアップはもちろん大切ですが、新しい技術を踏まえてどうつくるのか。他の技術との依存関係をどう整理するのか。最新技術だけに傾倒するのではなく、<i>あくまでも目的ありきで技術を扱える方と働きたいですね。</i>
          </p>
          <p>
            <span class="name name-red">
              Shinji
            </span>
            私たちの開発のスタイルには、<i>「普遍的なものを追いかけて、そのモデルを構築することで長く使えるシステムをつくる」という特徴があります。</i>一方で、最近はクラウドが主流になってきて、細かく切ってシステム化するのが流行になっています。この開発思想の接続をうまくできるような方に、来て欲しいですね。私たちのような古株のコンサルタントと、若手との橋渡しとしての役割も期待しています。
          </p>
          <p>
            <span class="name name-green">
              Tatsuki
            </span>
            技術スキルを伸ばすことはもちろん大切ですが、その大元にあるものに興味を持てる人が、豆蔵には合っていると思います。新しい技術でプログラムを書いてみたり、テスト環境で試して習熟度を高めていくことは、非常に重要です。ただし、そこからもう一歩踏み込んで、<i>その技術が生まれた背景や、どのようなシーンであればその技術が活かせるのか、といったことを、習慣的に考えて欲しい</i>と思っています。その結果として、10年、20年にわたって活用できるシステムを構築することができるはずです。
          </p>
          <p>
            <span class="name name-navy">
              Yasumasa
            </span>
            組込みの領域を担当するとは言え、そこに閉じるのではなく、他領域にもインプットとアウトプットを広げていける人に、来ていただきたいですね。組込みからIoTを通じてクラウドにつながるケースも、非常に増えています。<i>1つの領域にとらわれず、様々な領域に興味を持って取り組める方には、豆蔵の環境は合っている</i>と思いますね。最新技術に詳しいエキスパートが社内にいますし、大学との連携を行うこともあります。自分から機会を創り出したいと思っている方には、豆蔵はこれ以上に無いフィールドです。
          </p>
        </div>
        <div class="image">
          <img src="../assets/discussion_mgr/image07.jpg" alt="" class="over_display">
          <img src="../assets/discussion_mgr/image07_sp.jpg" alt="" class="under_display">
          <img src="../assets/discussion_mgr/image08.jpg" alt="" class="over_display">
          <img src="../assets/discussion_mgr/image08_sp.jpg" alt="" class="under_display">
        </div>
      </div>
    </DiscussionArticle>
  </div>
</template>

<script>
// @ is an alias to /src
import PageHeader from '@/components/discussion/PageHeader.vue';
import PeopleProfile from '@/components/discussion/PeopleProfile.vue';
import DiscussionArticle from '@/components/discussion/DiscussionArticle.vue';
export default {
  name: 'discussion_mgr',
  components: {
    PageHeader,
    PeopleProfile,
    DiscussionArticle
  },
}
</script>

<style lang="scss" scoped>
.discussion_mgr {
  position: relative;
  margin-bottom: 50px;
}
.people-wrap {
  margin: 0 auto;
  justify-content: center;
  @media print, screen and (min-width: 1161px) {
    display: flex;
  }
}
.article-body {
  margin: 0 auto;
  max-width: 910px;
  width: 100%;
  justify-content: space-between;
  margin-top: 100px;
  @media print, screen and (min-width: 1161px) {
    display: flex;
  }
  @media print, screen and (max-width: 1160px) { 
    max-width: 90%;
  }
  .text {
    margin: 0 auto;
    max-width: 560px;
    width: 100%;
    background-color: #fff;
    @media print, screen and (max-width: 1160px) { 
      max-width: 90%;
      margin-bottom: 50px;
    }
    .name {
      display: block;
      &.name-yellow {
        color: #9c6b00;
      }
      &.name-red {
        color: #bc0036;
      }
      &.name-green {
        color: #003f52;
      }
      &.name-navy {
        color: #2e3ea7;
      }
    }
    p {
      font-size: 12px;
    }
    i {
      font-style: normal;
      background: linear-gradient(transparent 50%, #ffcf82 50%); 
    }
  }
  .image {
    width: 100%;
    margin: 0 auto;
    @media print, screen and (min-width: 1161px) {
      max-width: 260px;
    }
    @media print, screen and (max-width: 1160px) {
      max-width: 500px;
    }
    img {
      margin-bottom: 50px;
      @media print, screen and (max-width: 1160px) {
        margin-bottom: 30px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
